module.exports = __webpack_public_path__ + "static/media/usdc.47ece234db9d42e0f89e0d8128e64588.svg";